"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ioEvents = void 0;
var ioEvents;
(function (ioEvents) {
    ioEvents["NotificationState"] = "NotificationState";
    ioEvents["SUBSCRIPTION_ADDED"] = "SUBSCRIPTION_ADDED";
    ioEvents["SUBSCRIPTIONS_UPDATED"] = "SUBSCRIPTIONS_UPDATED";
    ioEvents["GetNotificationState"] = "GetNotificationState";
    ioEvents["FEED_UPDATED"] = "FEED_UPDATED";
    ioEvents["USER_STATE"] = "USER_STATE";
    ioEvents["MESSAGE"] = "MESSAGE";
    ioEvents["REFRESH"] = "REFRESH";
})(ioEvents = exports.ioEvents || (exports.ioEvents = {}));
